export default "__VITE_ASSET__D_ssT3vx__"